import React, { useState, useEffect } from "react";
import DashboardLayout from "../LayoutNavbar/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../LayoutNavbar/Navbars/DashboardNavbar";
import { Input, Row, Col, Form, Card } from "antd";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import API from "api/endpoints";
import axiosInstance from "api/axiosInstance";

function Personal() {
  useEffect(() => {
    fetchEmployeesByEmail();
  }, []);
  const [employeeDetails, setEmployeeDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  async function fetchEmployeesByEmail() {
    try {
      setLoading(true);
      
      
        const response = await axiosInstance.get(API.employee.getMyDetail);
        const responseData = response.data;
    
        if (responseData) {
  setEmployeeDetails(responseData);
}
    
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <DashboardLayout>
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <DashboardNavbar />
        <div className="body flex-grow-1 px-3">
        <Card title="Personal Information" className="card-professional" loading={loading}>
  {employeeDetails && (
    <Form layout="vertical">
      {/* BASIC INFO */}
      <label className="mb-3">
        <i className="fa fa-info-circle" /> BASIC INFORMATION
      </label>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item label="Employee Number">
            <Input disabled value={employeeDetails.publicId} />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item label="First Name">
            <Input disabled value={employeeDetails.firstName} />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item label="Last Name">
            <Input disabled value={employeeDetails.lastName} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item label="Gender">
            <Input disabled value={employeeDetails.gender} />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item label="Marital Status">
            <Input disabled value={employeeDetails.maritalStatus} />
          </Form.Item>
        </Col>
      </Row>

      {/* CONTACT */}
      <label className="mb-3">
        <i className="fa fa-phone-square" /> CONTACT
      </label>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item label="Mobile Phone">
            <PhoneInput
              disabled
              value={employeeDetails.mobileno}
              defaultCountry="pk"
              inputStyle={{ width: "100%" }}
            />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item label="Work Email">
            <Input disabled value={employeeDetails.workEmail} />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item label="Personal Email">
            <Input disabled value={employeeDetails.email} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item label="Work Authorization US">
            <Input disabled value={employeeDetails.workAuthorizationUS || "N/A"} />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item label="Sponsorship Needed">
            <Input disabled value={employeeDetails.sponsorshipNeeded || "N/A"} />
          </Form.Item>
        </Col>
      </Row>

      {/* ADDRESS */}
      <label className="mb-3">
        <i className="fa fa-home" /> ADDRESS
      </label>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label="Street Address">
            <Input disabled value={employeeDetails.streetAddress} />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item label="City">
            <Input disabled value={employeeDetails.city} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item label="State">
            <Input disabled value={employeeDetails.state} />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item label="Postal Code">
            <Input disabled value={employeeDetails.postalCode} />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item label="Country">
            <Input disabled value={employeeDetails.country} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )}
</Card>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default Personal;
